var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12480:69738)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 12,
    rx: 12,
    ry: 12,
    fill: "#E84142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16045 17.0716C7.64886 17.0716 7.13727 17.0786 6.6248 17.0716C6.06363 17.0615 5.84294 16.6934 6.11804 16.2029C6.89157 14.8221 7.67738 13.4479 8.4588 12.0711C9.51767 10.2046 10.5768 8.33974 11.6363 6.47649C11.6825 6.39378 11.7341 6.3142 11.7907 6.23825C12.0272 5.9241 12.4234 5.91444 12.6309 6.24614C12.9819 6.80863 13.3058 7.3891 13.6401 7.963C13.8305 8.29119 14.0148 8.62333 14.2043 8.95196C14.5277 9.51181 14.5347 10.0708 14.2149 10.6355C13.3479 12.1647 12.4819 13.6945 11.617 15.2249C11.4191 15.5737 11.2221 15.9221 11.0163 16.2678C10.7004 16.8035 10.2301 17.0729 9.60659 17.072L8.16045 17.0716Z",
    fill: "#FEFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9263 17.0721C15.298 17.0721 14.67 17.0721 14.0423 17.0721C13.9032 17.0721 13.7633 17.0611 13.64 16.9905C13.3982 16.8522 13.3193 16.5679 13.4728 16.2885C13.7589 15.7619 14.0612 15.2477 14.3609 14.7309C14.693 14.1566 15.03 13.5849 15.366 13.0132C15.4107 12.9374 15.4595 12.8642 15.5122 12.7938C15.7368 12.4911 16.1211 12.484 16.3418 12.789C16.4735 12.9715 16.5858 13.1694 16.6999 13.3642C17.2308 14.2709 17.76 15.1777 18.2877 16.0844C18.3402 16.1719 18.3865 16.263 18.4264 16.3569C18.5549 16.6728 18.3996 16.9641 18.0701 17.0449C17.9183 17.0817 17.7656 17.0765 17.6129 17.0769C17.0504 17.0769 16.4884 17.0769 15.9263 17.0769V17.0721Z",
    fill: "#FEFDFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12480:69738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvax);
export default __webpack_public_path__ + "static/media/avax.02a2582316ca7260bf4d0d8caea64bd5.svg";
export { ForwardRef as ReactComponent };